export const instagramConstants = {
    INSTAGRAM_LOCATIONS_REQUEST: 'INSTAGRAM_LOCATIONS_REQUEST',
    INSTAGRAM_LOCATIONS_SUCCESS: 'INSTAGRAM_LOCATIONS_SUCCESS',
    INSTAGRAM_LOCATIONS_FAILURE: 'INSTAGRAM_LOCATIONS_FAILURE',
};
